/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, Modal, Offcanvas } from 'react-bootstrap';
import { useForm, FieldValues, SubmitHandler } from 'react-hook-form';
import { useEffect, useState, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import FeatherIcon from 'feather-icons-react';
import * as XLSX from 'xlsx';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';

import { tableSavedDataActions } from 'store/tableSavedData/tableSavedData.slice';
import Nomenclature from './nomenclature';
import SearchProduct from './search';
import Button from 'components/base/Button';
import ndsService from 'service/nds';
import legalEntitySettingsService from 'service/legalEntitySettings';
import productSearchService from 'service/productSearch';
import usePageSearchParams from 'utils/usePageSearchParams';
import legalEntityCurrencyRateLastService from 'service/legalEntityCurrencyRateLast';
import ModalPriceList from './modal-price-list';
import { useWindowWidth } from 'utils/useWindowSize';
import '../../styles.scss';

interface PrintingFilterProps {
  setModalCreate: (show: boolean) => void;
  setIsVatPayerValue: (show: boolean) => void;
  modalCreate?: any;
  isVatPayerValue?: any;
  ndsData?: any;
  setNdsData?: any;
  setNdsPrice?: any;
  ndsPrice?: any;
  setNdsPriceWholsale?: any;
  ndsPriceWholsale?: any;
  setProductInvoiceData?: any;
  productInvoiceData?: any;
  barcodeInputRef: any;
  newInvoiceId?: any;
  focusRef?: any;
  saleToMinus?: any;
  setSaleToMinus?: any;
  setIsForced?: any;
  setIsTabToWhosale?: any;
  setIsEnter?: any;
  tableRef?: any;
  setIsPageDown?: any;
  isPageDown?: any;
  ndsTransfer?: any;
  setNdsTransfer?: any;
}

const useDebounce = (func: (...args: any[]) => void, delay: number) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const debouncedFunction = (...args: any[]) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current); // Cancel previous timeout
    }
    timeoutRef.current = setTimeout(() => {
      func(...args);
      timeoutRef.current = null; // Clear ref after execution
    }, delay);
  };

  // Return the debounced function and a cancel method
  debouncedFunction.cancel = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  return debouncedFunction;
};

const PrintingFilter = ({
  newInvoiceId,
  modalCreate,
  setModalCreate,
  isVatPayerValue,
  setIsVatPayerValue,
  ndsData,
  setNdsData,
  setNdsPrice,
  ndsPrice,
  setNdsPriceWholsale,
  ndsPriceWholsale,
  setProductInvoiceData,
  productInvoiceData,
  barcodeInputRef,
  focusRef,
  saleToMinus,
  setSaleToMinus,
  setIsForced,
  setIsTabToWhosale,
  setIsEnter,
  tableRef,
  setIsPageDown,
  isPageDown,
  ndsTransfer,
  setNdsTransfer
}: PrintingFilterProps) => {
  const { t, i18n } = useTranslation();
  const windowSize: any = useWindowWidth();

  const dispatch: Dispatch<any> = useDispatch();

  const getSavedValues = useSelector(
    (state: any) => state?.tableSavedData?.tables?.[newInvoiceId]
  );

  console.log('focusRef', focusRef());

  const countryId = useSelector((state: any) => state?.auth?.user?.country_id);

  const [searchParams] = usePageSearchParams();
  const invoiceCurrencyId = searchParams?.get('currency_id');

  const { register, handleSubmit } = useForm();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const [modalShow, setModalShow] = useState(false);
  const [searchedValue, setSearchedValue] = useState('');
  const [isAutoTab, setIsAutoTab] = useState(false);
  const [lastCurrenciesData, setLastCurrenciesData] = useState<any>([]);
  const [modalPriceList, setModalPriceList] = useState(false);
  const [closeSearchTable, setCloseSearchTable] = useState(false);
  const [newProduct, setNewProduct] = useState(false);
  const [isForceQuantity, setIsForceQuantity] = useState(false);
  const [isAutoRefreshProduct, setIsAutoRefreshProduct] = useState(false);
  const [importedFromExcel, setImportedFromExcel] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  //Get Legal entity currency rate last
  useQuery(['GET_LAST_RATE'], async () => {
    await legalEntityCurrencyRateLastService
      .getList({
        offset: 0,
        limit: 100
      })
      .then((res: any) => {
        setLastCurrenciesData(res?.rates);
      });
  });

  //Get NDS
  const fetchData = useMemo(() => {
    return () => {
      ndsService
        .getList({ offset: 0, limit: 100, country_id: countryId, status: true })
        .then((res: any) => {
          isVatPayerValue && setNdsData(res?.vats[0].value ?? 0);
        });
    };
  }, [countryId]);

  const fetchDataLegalSettings = useMemo(() => {
    return () => {
      legalEntitySettingsService
        .getList({ offset: 0, limit: 100 })
        .then((res: any) => {
          setNdsPrice(res?.legal_entity_settings[0].extra_charge ?? 0);
          setNdsPriceWholsale(
            res?.legal_entity_settings[0].extra_charge_wholesale ?? 0
          );
          setNdsTransfer(res?.legal_entity_settings[0].markup_value ?? 0);
          setIsAutoTab(res?.legal_entity_settings[0].is_auto_tab ?? 0);
          setSaleToMinus(
            res?.legal_entity_settings[0]?.sale_in_negative ?? false
          );
          setIsForced(res?.legal_entity_settings[0]?.is_forced ?? false);
          setIsTabToWhosale(
            res?.legal_entity_settings[0]?.is_tab_inputs_all ?? false
          );
          setIsForceQuantity(
            res?.legal_entity_settings[0]?.is_force_quantity ?? false
          );
          setIsAutoRefreshProduct(
            res?.legal_entity_settings[0]?.is_auto_refresh_product ?? false
          );
          setIsEnter(res?.legal_entity_settings[0]?.is_enter ?? false);
          setIsPageDown(res?.legal_entity_settings[0]?.is_page_down ?? false);
        });
    };
  }, [countryId]);

  const onSubmit: SubmitHandler<FieldValues> = data => {
    console.log('data', data);
  };

  const { refetch: refetchInvoice } = useQuery(
    ['GET_PRODUCT_SEARCH'],
    async () => {
      const a = await productSearchService
        .getList({
          offset: 0,
          limit: 1000,
          barcode: searchedValue || undefined,
          is_global: true
        })
        .then((res: any) => {
          return res;
        });

      return a;
    },
    {
      enabled: !!searchedValue
    }
  );

  const { data: invoiceWithId, refetch: refetchInvoiceById } = useQuery(
    ['GET_PRODUCT_LIST', newInvoiceId],
    async () => {
      if (newInvoiceId !== '') {
        const b = await productSearchService
          .getListProduct({
            offset: 0,
            limit: 1000,
            invoice_id: newInvoiceId || undefined
          })
          .then((res: any) => {
            //focus to  barcode input
            barcodeInputRef.current?.focus();

            // if (!res?.products) {
            //   setProductInvoiceData([]);
            // }

            return res;
          });
        return b ?? [];
      }
    },
    {
      enabled:
        !!newInvoiceId &&
        (getSavedValues === undefined ||
          (Array.isArray(getSavedValues) && getSavedValues.length === 0))
    }
  );

  console.log('invoiceWithId', invoiceWithId);
  // const scrollToBottom = () => {
  //   window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  // };

  const debouncedHandleGetProduct = useDebounce(async (e: any) => {
    try {
      if (e?.key === 'Enter') {
        const dataa = await refetchInvoice();

        const createdData = dataa?.data?.products?.map((items: any) => {
          /* prettier-ignore */
          const measureUnitKindId =
            dataa?.data?.is_product === true
              ? items?.nomenclature?.measure_unit_kind?.id
              : items?.measure_unit_kind_id;

          const packageQuantity =
            dataa?.data?.is_product === true
              ? items?.package_quantity
              : items?.nomenclature?.package_quantity || 1;
          const quantity = items?.total_quantity
            ? Number(items?.total_quantity.toFixed(3))
            : 0;
          const fullPackages = Math.floor(quantity / packageQuantity);
          const remainingQuantity = quantity % packageQuantity;

          /* prettier-ignore */
          const newTotalQuantityDisplay =
            measureUnitKindId === '3c7cee55-ad41-4ee3-a409-a7bb5f428b36'
              ? `${fullPackages}/${remainingQuantity}`
              : items?.total_quantity
                ? new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 4,
                    useGrouping: true
                  })
                    .format(items?.total_quantity)
                    .replace(/,/g, ' ')
                : 0;

          let packageAmount = items?.price_in;
          let cost = items?.price_whosale;
          let allCost = items?.price;

          // Check if the item's currency_id matches any currency in lastCurrenciesData
          if (items.currency_id === invoiceCurrencyId) {
            packageAmount = items?.price_in;
            cost = items?.price_whosale;
            allCost = items?.price;
          } else {
            if (Array.isArray(lastCurrenciesData)) {
              for (const currencyData of lastCurrenciesData) {
                if (
                  currencyData?.from_currency_id === items?.currency_id &&
                  currencyData?.to_currency_id === invoiceCurrencyId
                ) {
                  // Apply the conversion rate
                  packageAmount = (
                    items?.price_in * currencyData?.to_currency_rate
                  ).toFixed(2);

                  cost = (
                    items?.price_whosale * currencyData?.to_currency_rate
                  ).toFixed(2);
                  allCost = (
                    items?.price * currencyData?.to_currency_rate
                  ).toFixed(2);
                }
              }
            } else {
              console.error(
                'lastCurrenciesData is not iterable',
                lastCurrenciesData
              );
            }
          }

          return {
            name:
              dataa?.data?.is_product === true
                ? items?.name
                : items?.nomenclature?.name,
            is_product: dataa?.data?.is_product ?? false,
            variation: items?.nomenclature?.is_variation ? 'ДА' : 'НЕТ',
            barcode_user:
              dataa?.data?.is_product === true
                ? items?.barcode
                : items?.nomenclature?.barcode,
            barcode_original: items?.nomenclature?.barcode_original,
            weght_code: items?.scale_code ?? 0,
            units: items?.nomenclature?.measure_unit?.name?.[i18n.language],
            measure_unit_kind_id: items?.nomenclature?.measure_unit_kind?.id,
            measure_unit_kind_pid:
              items?.nomenclature?.measure_unit_kind?.pid || 0,
            measure_unit_id: items?.nomenclature?.measure_unit_id,
            measure_unit_pid: items?.nomenclature?.measure_unit_pid || 0,
            // quantity: saleToMinus ? 0 : 1,
            quantity: 0,
            amount:
              dataa?.data?.is_product === true
                ? items?.package_quantity
                : items?.nomenclature?.package_quantity ?? 0,
            update_price: isAutoRefreshProduct === true ? true : false,
            package_amount: packageAmount,
            cost: cost ?? 0,
            all_cost: allCost ?? 0,
            transfer_cost: items?.price_enumeration ?? 0,
            partion_codes_map: items?.partion_codes_map,
            current_balance: newTotalQuantityDisplay,
            guid: items?.nomenclature?.id,
            gupid: items?.nomenclature?.pid || 0
          };
        });

        if (!dataa?.data || !createdData?.length) {
          setModalCreate(true);
          return;
        }

        // Here, dispatch data to Redux to store it in the table settings state

        if (productInvoiceData?.length > 0) {
          const foundProductIndex = productInvoiceData?.findIndex(
            (item: any) => {
              return item?.barcode_user === searchedValue;
            }
          );
          if (foundProductIndex !== -1) {
            const updatedProductInvoiceData = [...productInvoiceData];

            const quantityCheck =
              updatedProductInvoiceData[foundProductIndex].quantity || '0';

            let integerPart = 0;
            let numerator = 0;
            let denominator = 0;

            if (
              typeof quantityCheck === 'string' &&
              quantityCheck?.includes('/')
            ) {
              // eslint-disable-next-line
              [numerator, denominator] = quantityCheck?.split('/').map(Number);

              integerPart = numerator += 1; // Whole number part
              denominator = +denominator; // Remainder of the division
            } else {
              integerPart = +quantityCheck;
            }

            const quantityDisplay =
              typeof quantityCheck === 'string' && quantityCheck?.includes('/')
                ? `${integerPart}/${+denominator}`
                : (integerPart += 1);

            const updatedItem = {
              ...updatedProductInvoiceData[foundProductIndex]
            };

            if (
              updatedItem.measure_unit_kind_id ===
              '3c7cee55-ad41-4ee3-a409-a7bb5f428b36'
            ) {
              updatedProductInvoiceData[foundProductIndex].quantity =
                quantityDisplay;
            } else {
              updatedItem.quantity = (+updatedItem.quantity || 0) + 1;
            }

            updatedProductInvoiceData[foundProductIndex] = updatedItem;

            const [movedItem] = updatedProductInvoiceData.splice(
              foundProductIndex,
              1
            );
            updatedProductInvoiceData.unshift(movedItem);
            setProductInvoiceData(updatedProductInvoiceData);

            if (isAutoTab) {
              // when auto tab true focus to quantity
              setTimeout(() => {
                const firstProductIndex = 0;
                focusRef(`quantity_${firstProductIndex}`);
              }, 500);
            }
            setModalCreate(false);
            return;
          } else {
            setProductInvoiceData((prevData: any) => {
              if (isPageDown) {
                const newData = [...prevData, ...createdData];
                // scrollToBottom();
                if (tableRef.current) {
                  tableRef.current.scrollTo({
                    top: tableRef.current.scrollHeight,
                    behavior: 'smooth' // Enables smooth scrolling
                  });
                  window.scrollTo({
                    top: document.body.scrollHeight,
                    behavior: 'smooth'
                  });
                }
                barcodeInputRef.current?.select();
                if (isAutoTab) {
                  // when auto tab true focus to quantity
                  setTimeout(() => {
                    const lastProductIndex = productInvoiceData.length;
                    focusRef(`quantity_${lastProductIndex}`);
                  }, 500);
                }

                return newData;
              } else {
                const newData = [...createdData, ...prevData];

                barcodeInputRef.current?.select();
                if (isAutoTab) {
                  // when auto tab true focus to quantity
                  setTimeout(() => {
                    const firstProductIndex = 0;
                    focusRef(`quantity_${firstProductIndex}`);
                  }, 500);
                }

                return newData;
              }
            });
          }
        } else {
          setProductInvoiceData((prevData: any) => {
            if (isPageDown) {
              const newData = [...prevData, ...createdData];
              // scrollToBottom();
              if (tableRef.current) {
                tableRef.current.scrollTo({
                  top: tableRef.current.scrollHeight,
                  behavior: 'smooth' // Enables smooth scrolling
                });
                window.scrollTo({
                  top: document.body.scrollHeight,
                  behavior: 'smooth'
                });
              }
              barcodeInputRef.current?.select();
              if (isAutoTab) {
                // when auto tab true focus to quantity
                setTimeout(() => {
                  const lastProductIndex = productInvoiceData.length;
                  focusRef(`quantity_${lastProductIndex}`);
                }, 500);
              }

              return newData;
            } else {
              const newData = [...createdData, ...prevData];
              barcodeInputRef.current?.select();
              if (isAutoTab) {
                // when auto tab true focus to quantity
                setTimeout(() => {
                  const firstProductIndex = 0;
                  focusRef(`quantity_${firstProductIndex}`);
                }, 500);
              }

              return newData;
            }
          });
        }
      }
    } finally {
      setIsProcessing(false);
    }
  }, 500);

  // Use debouncing with a 300ms delay
  // const debouncedHandleGetProduct = useDebounce(handleGetProduct, 500);

  const handleExportClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
      setImportedFromExcel(true);
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = e => {
        if (e?.target?.result) {
          const data = new Uint8Array(e.target.result as ArrayBuffer);
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

          console.log('jsonData test', jsonData);

          // Start processing from the second row (index 1)
          const filteredData = jsonData
            .slice(1)
            .filter((row: any) =>
              row.some(
                (cell: any) =>
                  cell !== null && cell !== undefined && cell !== ''
              )
            );

          // Explicitly type the array and map
          const groupedDataArray: any[] = [];
          const groupedDataMap: { [key: string]: any } = {};

          const parseValue = (value: any) => {
            if (typeof value === 'string') {
              // Replace commas with dots and parse as a float
              return parseFloat(value.replace(',', '.'));
            }
            return value || 0;
          };

          filteredData.forEach((row: any) => {
            const barcodeUser = String(row[3]);
            if (!barcodeUser) return;

            const existingEntry = groupedDataMap[barcodeUser];

            if (!existingEntry) {
              // If no entry exists, create a new one
              const newEntry: any = {
                name: row[1] ?? '',
                barcode_user: barcodeUser,
                units: row[5],
                current_balance: 0,
                quantity: parseValue(row[4]),
                package_amount: parseValue(row[10]),
                cost: parseValue(row[12]),
                all_cost: parseValue(row[11]),
                amount: row[6] ?? 1,
                weght_code: row[7] ?? 0,
                variation: 'Нет',
                barcode_original: barcodeUser,
                update_price: isAutoRefreshProduct === true ? true : false,
                articul: row[2] ?? '',
                ikpu: row[8] ?? 0,
                party_number: row[9] ?? 0,
                with_nds: row[13] ?? 'Нет',
                category: row[14],
                from_excel: true,
                category_id: row[14],
                measure_unit_id: row[5]
              };
              groupedDataArray.push(newEntry);
              groupedDataMap[barcodeUser] = newEntry;
            } else {
              // Check if the name or other properties differ
              const nameChanged = existingEntry.name !== (row[1] ?? '');
              const otherPropertiesDiffer =
                existingEntry.articul !== (row[2] ?? '') ||
                existingEntry.units !== row[5] ||
                existingEntry.package_amount !== parseValue(row[10]) ||
                existingEntry.cost !== parseValue(row[12]) ||
                existingEntry.all_cost !== parseValue(row[11]) ||
                existingEntry.amount !== (row[6] ?? 1) ||
                existingEntry.weght_code !== (row[7] ?? 0) ||
                existingEntry.ikpu !== (row[8] ?? 0) ||
                existingEntry.party_number !== (row[9] ?? 0) ||
                existingEntry.with_nds !== (row[13] ?? 'Нет') ||
                existingEntry.category !== row[14];

              if (nameChanged || otherPropertiesDiffer) {
                // If any properties differ or the name changed, replace with the latest data
                const updatedEntry: any = {
                  name: row[1] ?? '',
                  barcode_user: barcodeUser,
                  units: row[5],
                  current_balance: existingEntry.current_balance, // Preserve the current balance
                  quantity: parseValue(row[4]),
                  package_amount: parseValue(row[10]),
                  cost: parseValue(row[12]),
                  all_cost: parseValue(row[11]),
                  amount: row[6] ?? 1,
                  weght_code: row[7] ?? 0,
                  variation: 'Нет',
                  barcode_original: barcodeUser,
                  update_price: isAutoRefreshProduct === true ? true : false,
                  articul: row[2] ?? '',
                  ikpu: row[8] ?? 0,
                  party_number: row[9] ?? 0,
                  with_nds: row[13] ?? 'Нет',
                  category: row[14],
                  from_excel: true,
                  category_id: row[14],
                  measure_unit_id: row[5]
                };
                // Remove the old entry from the array
                const index = groupedDataArray.findIndex(
                  entry => entry.barcode_user === barcodeUser
                );
                if (index !== -1) {
                  groupedDataArray.splice(index, 1, updatedEntry);
                } else {
                  groupedDataArray.push(updatedEntry);
                }
                groupedDataMap[barcodeUser] = updatedEntry;
              } else {
                // If all other properties are the same, just sum the quantities
                existingEntry.quantity += parseValue(row[4]);
              }
            }
          });

          // Update the productInvoiceData state with the parsed Excel data
          setProductInvoiceData((prevData: any) =>
            prevData.concat(groupedDataArray)
          );
        }
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const handleGetExcample = () => {
    const url = 'https://dev.test.cdn.api.rizo.uz/docs/zakup_shablon.xlsx';

    const link = document.createElement('a');
    link.href = url;
    link.download = 'Шаблон.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    if (countryId) {
      fetchData();
    }
  }, [countryId]);

  useEffect(() => {
    if (newInvoiceId) {
      fetchDataLegalSettings();
    }
  }, []);

  useEffect(() => {
    const fetchComingData = async () => {
      if (
        newInvoiceId &&
        (getSavedValues === undefined ||
          (Array.isArray(getSavedValues) && getSavedValues.length === 0))
      ) {
        try {
          const newData = await refetchInvoiceById();

          const createdData =
            newData &&
            newData?.data?.products?.map((items: any) => {
              const packageQuantity =
                items?.package_quantity !== undefined
                  ? items.package_quantity
                  : 1;
              const quantity =
                items?.quantity !== undefined ? String(items.quantity) : '0';
              const totalQuantity =
                items?.total_quantity !== undefined
                  ? String(items.total_quantity)
                  : '0';
              let integerPart = 0;
              let numerator = 0;
              let denominator = 1;

              let integerPartTotal = 0;
              let numeratorTotal = 0;
              let denominatorTotal = 1;

              if (quantity?.includes('.')) {
                [numerator, denominator] = quantity.split('.').map(Number);
                integerPart = numerator; // Whole number part
                denominator = +`0.${denominator}`; // Remainder of the division
              } else {
                integerPart = +quantity;
              }

              if (totalQuantity?.includes('.')) {
                [numeratorTotal, denominatorTotal] = totalQuantity
                  .split('.')
                  .map(Number);
                integerPartTotal = numeratorTotal; // Whole number part
                denominatorTotal = +`0.${denominatorTotal}`; // Remainder of the division
              } else {
                integerPartTotal = +totalQuantity;
              }

              const multipleFraction = Math?.round(
                +denominatorTotal * packageQuantity
              );

              const quantityDisplay = quantity?.includes('.')
                ? `${integerPart}/${Math.round(+denominator * packageQuantity)}`
                : integerPart;

              const totalQuantityDisplay = totalQuantity?.includes('.')
                ? `${integerPartTotal}/${multipleFraction}`
                : integerPartTotal;

              let packageAmount = items?.price_in;
              let cost = items?.price_whosale;
              let allCost = items?.price;

              // Check if the item's currency_id matches any currency in lastCurrenciesData
              if (items.currency_id === invoiceCurrencyId) {
                packageAmount = items?.price_in;
                cost = items?.price_whosale;
                allCost = items?.price;
              } else {
                for (const currencyData of lastCurrenciesData) {
                  if (
                    currencyData?.from_currency_id === items?.currency_id &&
                    currencyData?.to_currency_id === invoiceCurrencyId
                  ) {
                    // Apply the conversion rate
                    packageAmount = (
                      items?.price_in * currencyData?.to_currency_rate
                    ).toFixed(2);
                    cost = (
                      items?.price_whosale * currencyData?.to_currency_rate
                    ).toFixed(2);
                    allCost = (
                      items?.price * currencyData?.to_currency_rate
                    ).toFixed(2);
                  }
                }
              }

              return {
                name: items?.name,
                is_product: newData?.data?.is_product ?? false,
                variation: items?.nomenclature?.is_variation ? 'ДА' : 'НЕТ',
                barcode_user: items?.barcode,
                barcode_original: items?.nomenclature?.barcode_original,
                weght_code: items?.scale_code ?? 0,
                units:
                  items?.nomenclature?.measure_unit?.name?.[i18n?.language],
                quantity:
                  items?.nomenclature?.measure_unit_id ===
                  '443bfff1-61e0-4057-8583-d040dc5a0454'
                    ? quantityDisplay
                    : items?.quantity ?? 0,
                update_price: items?.update_price === true ? true : false,
                sale_with_partion_code:
                  items?.sale_with_partion_code === true ? true : false,
                amount: items?.package_quantity ?? 1,
                package_amount: packageAmount ?? 0,
                measure_unit_kind_id:
                  items?.nomenclature?.measure_unit_kind?.id,
                measure_unit_kind_pid:
                  items?.nomenclature?.measure_unit_kind?.pid || 0,
                measure_unit_id: items?.nomenclature?.measure_unit_id,
                measure_unit_pid: items?.nomenclature?.measure_unit_pid || 0,
                cost: cost ?? 0,
                all_cost: allCost ?? 0,
                transfer_cost: items?.price_enumeration ?? 0,

                /* prettier-ignore */
                current_balance:
                  items?.nomenclature?.measure_unit_id ===
                  '443bfff1-61e0-4057-8583-d040dc5a0454'
                    ? totalQuantityDisplay
                    : items?.total_quantity
                      ? new Intl.NumberFormat('en-US', {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 4,
                          useGrouping: true
                        })
                          .format(items?.total_quantity)
                          .replace(/,/g, ' ')
                      : 0,
                guid: items?.nomenclature?.id,
                gupid: items?.nomenclature?.pid || 0,
                serial_number: items?.partion_codes,
                partion_codes_map: items?.partion_codes_map
              };
            });

          setProductInvoiceData([...createdData, ...productInvoiceData]);
        } catch (error) {
          console.error('Error fetching invoice by ID:', error);
        }
      }
    };

    fetchComingData();
  }, []);

  useEffect(() => {
    if (productInvoiceData?.length > 0 && importedFromExcel === false) {
      dispatch(
        tableSavedDataActions.addTableData({
          id: newInvoiceId, // Use dynamic id as needed
          tableData: productInvoiceData // This includes the updated items
        })
      );
    }
  }, [productInvoiceData, dispatch, newInvoiceId, importedFromExcel]);

  useEffect(() => {
    if (
      productInvoiceData?.length === 0 &&
      getSavedValues !== undefined &&
      importedFromExcel === false
    ) {
      setProductInvoiceData(getSavedValues); // Set Redux state to local state
    }
  }, [productInvoiceData, getSavedValues, importedFromExcel]);

  return (
    <div>
      <Form
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        className="rounded mt-3"
      >
        <div className="printing-rows">
          <Form.Floating className="md-4">
            <Form.Control
              {...register('markup')}
              type="number"
              placeholder="Наценка в %"
              value={ndsPrice}
              onChange={e => setNdsPrice(e?.target?.value)}
              onFocus={e => e.target.select()}
              autoComplete="off"
            />
            <label htmlFor="floatingInputCustom">{t('markup_in')}</label>
          </Form.Floating>

          <Form.Floating className="md-4">
            <Form.Control
              {...register('wholesale')}
              type="number"
              placeholder={t('markup_wholesale')}
              value={ndsPriceWholsale}
              onChange={e => setNdsPriceWholsale(e?.target?.value)}
              onFocus={e => e.target.select()}
              autoComplete="off"
            />
            <label htmlFor="floatingInputCustom">{t('markup_wholesale')}</label>
          </Form.Floating>

          <Form.Floating className="md-4">
            <Form.Control
              disabled
              {...register('transfer')}
              type="number"
              placeholder={t('transfer')}
              value={ndsTransfer}
              onChange={e => setNdsTransfer(e?.target?.value)}
              onFocus={e => e.target.select()}
              autoComplete="off"
            />
            <label htmlFor="floatingInputCustom">{t('transfer')}</label>
          </Form.Floating>

          <Form.Group className="printing-check">
            <Form.Check
              {...register('wholesale')}
              type="switch"
              checked={isVatPayerValue}
              onChange={() => setIsVatPayerValue(!isVatPayerValue)}
              label={t('vat_will_apply')}
              className="cursor-pointer"
            />
          </Form.Group>

          <Form.Floating className="nds md-4">
            <Form.Control
              disabled
              {...register('nds')}
              type="text"
              placeholder={`${t('vat')} %`}
              value={ndsData}
              onChange={e => setNdsData(e?.target?.value)}
              onFocus={e => e.target.select()}
              autoComplete="off"
            />
            <label htmlFor="floatingInputCustom">{`${t('vat')} %`}</label>
          </Form.Floating>

          <Button
            disabled={productInvoiceData?.length > 0 ? false : true}
            variant="primary"
            onClick={() => setModalPriceList(true)}
          >
            {t('price_tag')}
          </Button>
        </div>

        <div
          className={
            windowSize > 768
              ? 'd-flex gap-2 mt-4'
              : 'd-flex flex-column gap-2 mt-4'
          }
        >
          <div className="d-flex gap-2">
            <Form.Floating>
              <Form.Control
                {...register('barcode')}
                ref={barcodeInputRef}
                type="text"
                placeholder={t('scan_barcode')}
                onChange={e => setSearchedValue(e?.target?.value)}
                autoComplete="off"
                onKeyDown={e => {
                  if (e.key === 'Enter' && !isProcessing) {
                    setIsProcessing(true);
                    debouncedHandleGetProduct(e);
                  }
                }}
                onFocus={e => e.target.select()}
              />
              <label htmlFor="floatingInputCustom">{t('scan_barcode')}</label>
            </Form.Floating>

            <div className="d-flex justify-content-between gap-2">
              <Button
                className="d-flex align-items-center gap-2"
                variant="primary"
                onClick={() => {
                  setModalCreate(true);
                  setNewProduct(true);
                }}
              >
                <FontAwesomeIcon icon={faPlus} />
                {t('new')}
              </Button>
            </div>
          </div>

          <div className="d-flex gap-2">
            <Button
              variant="outline-primary"
              onClick={() => setModalShow(true)}
            >
              <FontAwesomeIcon icon={faPlus} className="me-2" />
              {t('products')}
            </Button>

            <Button
              disabled={productInvoiceData?.length > 0 ? true : false}
              variant="outline-primary"
              onClick={handleExportClick}
            >
              <FeatherIcon icon="download-cloud" className="me-2" size={20} />
              {t('import')}
            </Button>

            <Button variant="outline-info" onClick={handleGetExcample}>
              <FeatherIcon icon="download-cloud" className="me-2" size={20} />
              {t('sample')}
            </Button>

            <input
              type="file"
              ref={fileInputRef}
              style={{ display: 'none' }}
              onChange={handleFileChange}
              accept=".xlsx, .xls" // Specify the file types you want to allow
            />
          </div>
        </div>

        <Modal
          show={modalShow}
          onHide={() => {
            setModalShow(false);
            setCloseSearchTable(true);
          }}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          backdrop="static"
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {t('selection_purchase')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <SearchProduct
              setModalShow={setModalShow}
              productInvoiceData={productInvoiceData}
              setProductInvoiceData={setProductInvoiceData}
              focusRef={focusRef}
              isAutoTab={isAutoTab}
              saleToMinus={saleToMinus}
              invoiceCurrencyId={invoiceCurrencyId}
              lastCurrenciesData={lastCurrenciesData}
              closeSearchTable={closeSearchTable}
              setCloseSearchTable={setCloseSearchTable}
              isForceQuantity={isForceQuantity}
              isAutoRefreshProduct={isAutoRefreshProduct}
              isPageDown={isPageDown}
            />
          </Modal.Body>
        </Modal>

        <Modal
          show={modalPriceList}
          onHide={() => setModalPriceList(false)}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          backdrop="static"
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {t('printing_price_tags')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ModalPriceList productInvoiceData={productInvoiceData} />
          </Modal.Body>
        </Modal>

        <Offcanvas
          show={modalCreate}
          onHide={() => {
            setModalCreate(false);
            setNewProduct(false);
          }}
          placement="end"
          backdrop="static"
          keyboard={false}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title style={{ fontSize: '24px', fontWeight: '600' }}>
              {t('add_nomunclature')}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nomenclature
              setModalCreate={setModalCreate}
              searchedValue={searchedValue}
              setProductInvoiceData={setProductInvoiceData}
              productInvoiceData={productInvoiceData}
              isAutoTab={isAutoTab}
              focusRef={focusRef}
              newProduct={newProduct}
              isPageDown={isPageDown}
            />
          </Offcanvas.Body>
        </Offcanvas>
      </Form>
    </div>
  );
};

export default PrintingFilter;
